import type { TagViewTableRowProps } from '../types';

const defaultViewProps: Partial<TagViewTableRowProps> = {
  useLastActivityTime: true,
  usePostCount: true
};

export default defaultViewProps;
